module.exports={render:function (){with(this) {
  return _h('section', {
    staticClass: "ion-content ",
    class: ['content-' + theme]
  }, [_h('div', {
    staticClass: "scroll-content"
  }, [_t("default")]), " ", _t("ion-refresher")])
}},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f4661fa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/src/content.vue
// module id = 164
// module chunks = 0